export default __webpack_public_path__ + "static/media/chevron-right.3eab83e6.svg";